// extracted by mini-css-extract-plugin
export var actionButton = "_go-t";
export var buttonContainer = "_go-0";
export var buttonContainer2 = "_go-1";
export var buttonSection = "_go-2";
export var details = "_go-3";
export var dropdownItem = "_go-5";
export var dropdownItemsContainer = "_go-4";
export var fileInput = "_go-r";
export var headerButton = "_go-6";
export var icon = "_go-7";
export var input = "_go-8";
export var macroListItem = "_go-9";
export var mainContent = "_go-a";
export var microText = "_go-b";
export var modal = "_go-w";
export var optionsButton = "_go-c";
export var paperclip = "_go-s";
export var pillContent = "_go-d";
export var preview = "_go-e";
export var preview2 = "_go-f";
export var quillEditor = "_go-q";
export var selectedMacro = "_go-g";
export var sidebar = "_go-h";
export var sidebarHeader = "_go-j";
export var sidebarList = "_go-i";
export var sidebarListItem = "_go-k";
export var sidebarSearch = "_go-l";
export var snoozeDurationWrapper = "_go-v";
export var statusPillContainer = "_go-m";
export var tagsContainer = "_go-n";
export var unselectedMacro = "_go-o";
export var variable = "_go-u";
export var wrapper = "_go-p";